import React from 'react';
import VoiceCallComponent from '../components/VoiceCallComponent';

export default function VoiceChat() {
  return (
    <div className="pt-24 min-h-screen bg-[#0a0a0a] px-4 flex flex-col items-center">
      <div className="w-full max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-bold text-center mb-4 text-white">AI Support</h1>
        <p className="text-gray-400 text-center mb-8 max-w-2xl mx-auto">
          Talk to our intelligent AI assistant to get quick answers to your questions, explore our services, or resolve any issues you might have.
        </p>
        <VoiceCallComponent />
      </div>
    </div>
  );
}
